import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import coin from "assets/images/singhCoinCurrency.png";
import colors from "assets/theme-dark/base/colors";
import { Card } from "@mui/material";

function ClaimedCards({ color, icon, name, description, description2, value }) {
  const { black, singh, singhGrey } = colors;
  return (
    <Card
      sx={{
        marginTop: "1rem",
        padding: 1,
        backgroundColor: `${black.main}`,
      }}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox width="70%" display="flex" gap="1rem" alignItems="center">
          <MDBox>
            <MDTypography color={color} fontSize="25px">
              {icon}
            </MDTypography>
          </MDBox>
          <MDBox
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "0.3rem",
            }}
          >
            <MDTypography variant="button" fontWeight="bold">
              {name}
            </MDTypography>
            <MDTypography
              variant="caption"
              fontWeight="regular"
              sx={{
                width: "80%",
                wordWrap: "break-word",
              }}
            >
              {/* <AccountBalanceWalletIcon sx={{ marginRight: "0.2rem" }} /> */}
              {description}
            </MDTypography>
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {description2}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox>
          <MDTypography
            // sx={{ marginRight: "90px" }}
            // variant="button"
            color={color}
            fontWeight="medium"
            textGradient
          >
            {value}
            <img src={coin} height="40px" />
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

// Typechecking props of the Claimed
ClaimedCards.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]).isRequired,
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  // value: PropTypes.string.isRequired,
};

export default ClaimedCards;
